export default "__VITE_ASSET__DJTX4kDi__"